// extracted by mini-css-extract-plugin
export default {"l_AlertIcon_main":"AlertIcon_l_AlertIcon_main__QWoh1","l_AlertIcon_img":"AlertIcon_l_AlertIcon_img__7FHxr"};